module.exports = __webpack_public_path__ + "img/drf.37921ea7.png";